var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-auto"},[_c(_vm.getGameComponent,{tag:"component",attrs:{"is-muted":_vm.isMuted},on:{"gameOver":_vm.gameOver,"toggleSound":_vm.toggleSound}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }